import type { Cycle, EquipmentSchedule, EventType } from '@/types/equipment'

/** Most frequent first, as the backend orders them (`task-procedure.ts`). */
const CYCLE_ORDER: readonly Cycle[] = ['daily', 'weekly', 'biweekly', 'monthly', 'quarterly', 'semiannually', 'yearly']

/**
 * The form (procedure) each event type carries on a unit's type (z8nrz7fgzw),
 * by the backend's rule for a task no cycle produced: the one linked on its
 * repeat cycle, else the one on its least frequent cycle. A form belongs to the
 * event type it is linked to, so an event type with none is absent.
 */
export function formsByEventType(
  schedule: EquipmentSchedule | undefined,
  repeatCycle?: string | null,
): Map<EventType, { id: string; name: string }> {
  const out = new Map<EventType, { id: string; name: string }>()
  if (!schedule) return out
  for (const cycle of CYCLE_ORDER) {
    for (const [code, form] of Object.entries(schedule[cycle]?.procedures ?? {})) {
      if (form) out.set(code as EventType, form) // later (less frequent) cycles win
    }
  }
  const repeat = repeatCycle ? schedule[repeatCycle as Cycle]?.procedures : undefined
  for (const [code, form] of Object.entries(repeat ?? {})) {
    if (form) out.set(code as EventType, form)
  }
  return out
}
